module.exports = __webpack_public_path__ + "static/media/vehiculo.116afdbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vehiculo.svg
// module id = 1555
// module chunks = 0